import BApp from "../../modules/BApp";
import BProfileArticleThumbnails from "./BProfileArticleThumbnails";

export default class BProfileArticlePrioritySection
{
	constructor(el)
	{
		this.el = el;
	}

	static selector = () => `.profile-article-priority-section`;

	setFromResponse(response)
	{
		let articles = [];

		response.data.forEach(article => {
			if (article.priority == this.getPriority()) {
				articles.push(BApp.createElement(article.templates.profileArticleThumbnail, "ul"));
			}
		});

		this.getprofileArticleThumbnail().setArticles(articles);

		this.el.hidden = articles.length ? false : true;
	}

	getPriority()
	{
		return parseInt(this.el.dataset.priority);
	}

	getprofileArticleThumbnail()
	{
		return new BProfileArticleThumbnails(this.el.querySelector(BProfileArticleThumbnails.selector()));
	}
}
